/* Working Plant: winter shipping protection cart engine.
   Loaded only while Theme settings > Cart > "Winter protection active"
   is on (see snippets/wp-winter-protection.liquid, part 'engine'), and
   it never runs in the theme editor (design mode renders no config).

   Rule: exactly ONE Winter Shipping Protection line at quantity 1, at
   the tier that matches the cart's plant count. The line is removed
   when no plants remain. Plant count = sum over cart lines of
   (line quantity x plants per unit). Gift cards never count. The
   protection line itself never counts.

   What counts as a plant (fixed 2026-11-02): ONLY lines whose vendor
   is "House Plant Dropship" — every plant, bundle, and subscription
   box in the catalog carries that vendor (143 of 143 products), and
   every merch product carries vendor "Printify" (17 of 17: stickers,
   mugs, caps, candle, tote, and the rest). Merch-only carts therefore
   count 0 plants and never get a fee line. Lines with any other or
   missing vendor never count either: when in doubt, do not charge.

   Bundle plant counts (supplier-confirmed):
     Best Selling Bundle 4, Rare Plant Bundle 4, Monstera Bundle 3,
     2 Peperomia Variety Pack 2, 3 Peperomia Variety Pack 3,
     New Plant Parent Bundle 1,
     Air Purifying Bundle 4, Easy Care Bundle 4, Low Light Bundle 4,
     Pet Friendly Bundle 4, 3-inch Tropical Bundle 4.
   Any other product whose title mentions a bundle or a variety pack
   falls back to 3 plants per unit. Orders over 12 plants stay on the
   top tier.

   Tiers: 1 to 2 plants $3.50 (S), 3 to 6 plants $6.50 (M),
   7 or more plants $8.50 (L). Variant ids arrive via
   window.__wpWinterProtection, resolved by SKU at render time. */
(function () {
  if (window.__wpWinterEngine) return;
  window.__wpWinterEngine = true;

  var config = window.__wpWinterProtection;
  if (!config || !config.variants) return;

  var SOURCE = 'wp-winter-protection';
  var FEE_VARIANT_IDS = [config.variants.S, config.variants.M, config.variants.L];
  // Only the dropship supplier's lines are plants. Merch (Printify)
  // and anything else never counts toward the plant total.
  var PLANT_VENDOR = 'House Plant Dropship';

  var bundleCounts = {
    'best-selling-bundle': 4,
    'rare-plant-bundle': 4,
    'monstera-bundle': 3,
    '2-peperomia-plants-variety-pack-in-4-pots-baby-rubber-plants': 2,
    '3-different-peperomia-plants-in-4-pots-baby-rubber-plants': 3,
    'new-plant-parent-bundle': 1,
    'air-purifying-variety-bundle': 4,
    'easy-care-variety-bundle': 4,
    'low-light-bundle': 4,
    'pet-friendly-variety-bundle': 4,
    '3-tropical-plant-variety-bundle': 4
  };

  function cartRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function plantsPerUnit(item) {
    if (Object.prototype.hasOwnProperty.call(bundleCounts, item.handle)) {
      return bundleCounts[item.handle];
    }
    var title = (item.product_title || '').toLowerCase();
    var handle = (item.handle || '').toLowerCase();
    if (
      title.indexOf('bundle') !== -1 ||
      title.indexOf('variety pack') !== -1 ||
      handle.indexOf('bundle') !== -1 ||
      handle.indexOf('variety-pack') !== -1
    ) {
      return 3;
    }
    return 1;
  }

  function desiredVariantId(plantCount) {
    if (plantCount <= 0) return null;
    if (plantCount <= 2) return config.variants.S;
    if (plantCount <= 6) return config.variants.M;
    return config.variants.L;
  }

  function analyze(cart) {
    var plantCount = 0;
    var feeLines = [];
    cart.items.forEach(function (item, index) {
      if (FEE_VARIANT_IDS.indexOf(item.variant_id) !== -1 || item.handle === 'winter-shipping-protection') {
        feeLines.push({ line: index + 1, variantId: item.variant_id, quantity: item.quantity });
        return;
      }
      if (item.product_type === 'Gift Card' || item.gift_card) return;
      if (item.vendor !== PLANT_VENDOR) return;
      plantCount += plantsPerUnit(item) * item.quantity;
    });
    return { plantCount: plantCount, feeLines: feeLines, desired: desiredVariantId(plantCount) };
  }

  function isSatisfied(state) {
    if (state.desired === null) return state.feeLines.length === 0;
    return (
      state.feeLines.length === 1 &&
      state.feeLines[0].variantId === state.desired &&
      state.feeLines[0].quantity === 1
    );
  }

  function sectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (component) {
      if (component.dataset.sectionId) ids.push(component.dataset.sectionId);
    });
    return ids;
  }

  function dispatchCartUpdate(cart, sections) {
    var update = new Event('cart:update', { bubbles: true });
    update.detail = {
      resource: cart,
      sourceId: SOURCE,
      data: {
        source: SOURCE,
        itemCount: cart.item_count,
        sections: sections || {}
      }
    };
    document.dispatchEvent(update);
  }

  var fixing = false;

  function fix(cart) {
    var state = analyze(cart);
    if (isSatisfied(state)) return;
    if (fixing) return;
    fixing = true;

    var ids = sectionIds();
    var body;
    var url;

    if (state.desired !== null && state.feeLines.length === 0) {
      url = cartRoot() + 'cart/add.js';
      body = { id: state.desired, quantity: 1 };
    } else {
      url = cartRoot() + 'cart/update.js';
      var updates = {};
      state.feeLines.forEach(function (feeLine) {
        updates[feeLine.variantId] = 0;
      });
      if (state.desired !== null) updates[state.desired] = 1;
      body = { updates: updates };
    }
    if (ids.length) body.sections = ids.join(',');

    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (response) { return response.json(); })
      .then(function (response) {
        if (response && response.status) return null;
        var sections = (response && response.sections) || null;
        return fetch(cartRoot() + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (freshCart) {
            fixing = false;
            dispatchCartUpdate(freshCart, sections);
          });
      })
      .catch(function () {
        fixing = false;
      });
  }

  function check() {
    fetch(cartRoot() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { fix(cart); })
      .catch(function () {});
  }

  document.addEventListener('cart:update', function (event) {
    if (event.detail && event.detail.data && event.detail.data.source === SOURCE) return;
    if (fixing) return;
    // Let the theme finish reacting to the original update first.
    setTimeout(check, 60);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', check);
  } else {
    check();
  }
})();
